var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8998 8.80029H10.3998C9.24002 8.80029 8.2998 9.74049 8.2998 10.9002V21.4002C8.2998 22.56 9.24002 23.5002 10.3998 23.5002H20.8998C22.0596 23.5002 22.9998 22.56 22.9998 21.4002V10.9002C22.9998 9.74049 22.0596 8.80029 20.8998 8.80029Z",
    stroke: "#7269EF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 17.2C2.945 17.2 2 16.255 2 15.1V4.6C2 3.445 2.945 2.5 4.1 2.5H14.6C15.755 2.5 16.7 3.445 16.7 4.6",
    stroke: "#7269EF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.28cd9ed4240f3306385bc8c8acd083bd.svg";
export { ForwardRef as ReactComponent };